import type { MoretonBayBillingInitializer } from '@ctct/application-layer';
import { envs } from '@ctct/infrastructure-layer';
import { PayflowTopBar } from '@ctct/presentation-layer';
import { ThankYouWidget, useThankYouWidget, AlertWidget, useAlertWidget } from '@ctct/react-app-layer';
import type { OrderSummaryHooks, PayflowTopBarHooks } from '@ctct/state-client-layer';
import { useBillingInfoPageStore } from '@ctct/state-client-layer';

interface Props {
  initializer: MoretonBayBillingInitializer;
  externalHooks: {
    useReturnUrl: PayflowTopBarHooks['useReturnUrl'];
    useReturnLabel: PayflowTopBarHooks['useReturnLabel'];
    useIsXeroAddonSelected: OrderSummaryHooks['useIsXeroAddonSelected'];
  };
}

const linkToDashboard = `https://app${envs.getEnv()}constantcontact.com/home`;

const alertHooks = {
  useAlerts: () => useBillingInfoPageStore((state) => state.alerts),
};

export const ConfirmationPage = ({ initializer, externalHooks }: Props) => {
  const props = useThankYouWidget({
    initializer,
    externalHooks,
    version: 'moreton-bay',
  });

  const alertProps = useAlertWidget({
    initializer,
    pageStore: useBillingInfoPageStore,
    hooks: alertHooks,
  });

  return (
    <>
      <PayflowTopBar logoLink={linkToDashboard} exitLink={linkToDashboard} />
      <div className="moreton-bay-confirmation">
        <AlertWidget {...alertProps} />
        <ThankYouWidget {...props} version="moreton-bay" />
      </div>
    </>
  );
};
